export default __webpack_public_path__ + "static/media/arrow-bold.7ebb6912.svg";